import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { UseMutationResult } from "@tanstack/react-query";

import { API_ROUTES } from "../../../api/ApiRoutes";
import createRegulatorPortalInstance from "../../../api/RegulatorPortalInstance";
import { parseComplianceRules } from "./parseComplianceRule";
import { COMPLIANCE_RULES_QUERY_KEY } from "./useComplianceRules";
import type { ComplianceRule, ComplianceRuleWritePayload } from "./types";

export const updateComplianceRule = async (
  payload: ComplianceRuleWritePayload,
): Promise<ComplianceRule | null> => {
  const response = await createRegulatorPortalInstance().put(
    API_ROUTES.REGULATOR_COMPLIANCE_RULES,
    payload,
  );
  return parseComplianceRules(response.data)[0] ?? null;
};

export const useUpdateComplianceRule = (): UseMutationResult<
  ComplianceRule | null,
  Error,
  ComplianceRuleWritePayload
> => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["regulator-portal", "update-rule"],
    mutationFn: updateComplianceRule,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: COMPLIANCE_RULES_QUERY_KEY,
      });
    },
  });
};
